import { ISubimissonPublicationPagedResponse } from '../../../../model/sep/submission-publications/response/submissin-publication-paged-response';
import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SubmissionPublicationAppService from '../../../../application/platform/sep/subimission-publication/subimission-publication-app-service';
import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submissin-publication-paged-request';
import LinearProgress from '@mui/material/LinearProgress';
import Chip from '@mui/material/Chip';
import moment from 'moment';
import { Pagination } from '../../../../model/pagination';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import IconButton from '@mui/material/IconButton';
import SubmissionPublicationDetail, { ISubmissionPublicationDetailProps } from './submisson-publication-detail';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';

export interface ISubmissionPublicationDataTableProps {
    parameters: ISubmissionPublicationPagedRequest
    submissionPublicationId: number | undefined;
};


export default function SubmissionPublicationDataTable({ props }: { props: ISubmissionPublicationDataTableProps }) {
    const [response, setResponse] = useState<Pagination<ISubimissonPublicationPagedResponse>>(new Pagination<ISubimissonPublicationPagedResponse>);
    const [submissionPublicationDataTableProps, setSubmissionPublicationDataTableProps] = useState<ISubmissionPublicationDataTableProps>(props);
    const [loadMoreData, setLoadMoreData] = useState(true);

    const closeDetail = () => {
        setSubmissionPublicationDetailProps({ ...submissionPublicationDetailProps, id: undefined });
    }

    const [submissionPublicationDetailProps, setSubmissionPublicationDetailProps] = useState<ISubmissionPublicationDetailProps>({
        onClose: closeDetail
    } as ISubmissionPublicationDetailProps);

    const columns: GridColDef<ISubimissonPublicationPagedResponse>[] = [
        { field: 'id', headerName: 'Nº', width: 90 },
        {
            field: 'sendDate',
            headerName: 'Enviada em',
            minWidth: 170,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
            field: 'publishDate',
            headerName: 'Publicar em',
            minWidth: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'title',
            headerName: 'Título',
            minWidth: 220
        },      {
            field: 'clientName',
            headerName: 'Entidade',
            minWidth: 220
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 130,
            renderCell: (params) => {
                let chip = <Chip label={params.row.status} color="primary" />
                if (params.row.statusId === 1) {
                    chip = <Chip label={params.row.status} color="primary" />
                } else if (params.row.statusId === 2) {
                    chip = <Chip label={params.row.status} color="secondary" />
                } else if (params.row.statusId === 3) {
                    chip = <Chip label={params.row.status} color="warning" />
                } else if (params.row.statusId === 4) {
                    chip = <Chip label={params.row.status} color="error" />
                } else if (params.row.statusId === 5) {
                    chip = <Chip label={params.row.status} color="success" />
                }
                return chip;
            }
        },
        {
            field: 'userSenderName',
            headerName: 'Enviada por',
            minWidth: 160
        }, {
            field: "action",
            headerName: "",
            sortable: false,
            width: 60,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <IconButton color="primary" aria-label="Detahes" component="label" onClick={async () => {
                        setSubmissionPublicationDetailProps({ ...submissionPublicationDetailProps, id: params.row.id });
                    }}>
                        <DisplaySettingsIcon />
                    </IconButton>);


            }
        }
    ];

    useEffect(() => {
        loadData(props.parameters);
        setSubmissionPublicationDataTableProps(props);

        if (props.submissionPublicationId !== undefined) {
            setSubmissionPublicationDetailProps({ ...submissionPublicationDetailProps, id: props.submissionPublicationId });
        }
    }, [props]);

    useEffect(() => {
        loadData(submissionPublicationDataTableProps.parameters);
    }, [submissionPublicationDataTableProps.parameters]);


    useEffect(() => {
        if (submissionPublicationDetailProps.id === undefined) {
            loadData(submissionPublicationDataTableProps.parameters);
        }
    }, [submissionPublicationDetailProps.id]);

    const loadData = (parameters: ISubmissionPublicationPagedRequest) => {
        (async () => {
            if (parameters !== undefined) {
                setLoadMoreData(true);
                const data = await SubmissionPublicationAppService.get(parameters);
                setResponse(data);
                setLoadMoreData(false);
            }
        })();
    }

    return (<React.Fragment>
        <SubmissionPublicationDetail props={submissionPublicationDetailProps} />
        <DataGrid
            rows={response.items}
            columns={columns}
            page={submissionPublicationDataTableProps?.parameters.page}
            pageSize={response.pageSize}
            rowCount={response.totalRecords}
            disableSelectionOnClick
            onPageChange={(newPage) => {
                setSubmissionPublicationDataTableProps({ ...submissionPublicationDataTableProps, parameters: { ...submissionPublicationDataTableProps.parameters, page: newPage } });
            }}
            paginationMode="server"
            components={{
                LoadingOverlay: LinearProgress,
            }}
            loading={loadMoreData}
            rowsPerPageOptions={[response.pageSize]}
            experimentalFeatures={{ newEditingApi: true }}
            localeText={dataGridLocaleConfig}
        />
    </React.Fragment>
    )
}